import { all, call, put, takeEvery } from "redux-saga/effects";
import * as supportRequestActions from "../slices/supportRequestSlice";
import supportRequestApis from "src/api/supportRequest";
import { common } from "src/types";
import { constants } from "src/constants/common";

function* getSupportRequestsListAdminSaga({
  payload,
}: ReturnType<
  typeof supportRequestActions.getSupportRequestsListAdminRequest
>) {
  try {
    const response: common.ResponseGenerator = yield call(
      supportRequestApis.getSupportRequestsListAdmin,
      payload
    );
    yield put(
      supportRequestActions.getSupportRequestsListAdminSuccess(response)
    );
  } catch (error) {
    yield put(
      supportRequestActions.getSupportRequestsListAdminError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* createSupportRequestSaga({
  payload,
}: ReturnType<typeof supportRequestActions.createSupportRequestRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      supportRequestApis.createSupportRequest,
      payload
    );
    yield put(
      supportRequestActions.createSupportRequestSuccess(response?.data)
    );
  } catch (error) {
    yield put(
      supportRequestActions.createSupportRequestError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* updateSupportRequestStatusAdminSaga({
  payload,
}: ReturnType<
  typeof supportRequestActions.updateSupportRequestStatusAdminRequest
>) {
  try {
    const response: common.ResponseGenerator = yield call(
      supportRequestApis.updateSupportRequestStatusAdmin,
      payload
    );
    yield put(
      supportRequestActions.updateSupportRequestStatusAdminSuccess(
        response?.data
      )
    );
  } catch (error) {
    yield put(
      supportRequestActions.updateSupportRequestStatusAdminError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

export default function* supportRequestSaga() {
  yield all([
    takeEvery(
      supportRequestActions.getSupportRequestsListAdminRequest,
      getSupportRequestsListAdminSaga
    ),
    takeEvery(
      supportRequestActions.createSupportRequestRequest,
      createSupportRequestSaga
    ),
    takeEvery(
      supportRequestActions.updateSupportRequestStatusAdminRequest,
      updateSupportRequestStatusAdminSaga
    ),
  ]);
}
